/**
 * Banner system: rotation auto + close dismissible (localStorage 1 ngày).
 */
(function () {
    const DISMISS_TTL_HOURS = 24;
    const STORAGE_PREFIX = 'banner_dismissed_';

    function isDismissed(position) {
        const v = localStorage.getItem(STORAGE_PREFIX + position);
        if (!v) return false;
        const ts = parseInt(v, 10);
        if (!ts) return false;
        const ageHours = (Date.now() - ts) / 3600000;
        if (ageHours > DISMISS_TTL_HOURS) {
            localStorage.removeItem(STORAGE_PREFIX + position);
            return false;
        }
        return true;
    }

    function setDismissed(position) {
        localStorage.setItem(STORAGE_PREFIX + position, String(Date.now()));
    }

    function initSlot(slot) {
        const position = slot.dataset.position;

        // Check dismissed (sidebar only — header banner không close được)
        if ((position === 'left_sidebar' || position === 'right_sidebar') && isDismissed(position)) {
            slot.style.display = 'none';
            return;
        }

        // Close button
        const closeBtn = slot.querySelector('.banner-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                slot.style.transform = 'translateX(' + (position === 'left_sidebar' ? '-' : '') + '120%)';
                slot.style.opacity = '0';
                setTimeout(() => { slot.style.display = 'none'; }, 250);
                setDismissed(position);
            });
        }

        // Rotation + manual nav (dots + arrows)
        const rotation = slot.dataset.rotation === '1';
        const interval = parseInt(slot.dataset.interval, 10) || 5000;
        const items = Array.from(slot.querySelectorAll('.banner-item'));
        const dots  = Array.from(slot.querySelectorAll('.banner-dot'));
        const arrows = Array.from(slot.querySelectorAll('.banner-arrow'));

        if (items.length <= 1) return; // chỉ 1 banner — không cần nav

        let idx = 0;
        let timer = null;

        function setActive(next) {
            const n = ((next % items.length) + items.length) % items.length; // wrap âm
            if (n === idx) return;
            items[idx].classList.remove('is-active');
            items[n].classList.add('is-active');
            if (dots[idx]) { dots[idx].classList.remove('is-active'); dots[idx].setAttribute('aria-selected', 'false'); }
            if (dots[n])   { dots[n].classList.add('is-active');      dots[n].setAttribute('aria-selected', 'true'); }
            idx = n;
        }

        function startAuto() {
            if (!rotation || timer) return;
            timer = setInterval(() => setActive(idx + 1), interval);
        }
        function stopAuto() {
            if (timer) { clearInterval(timer); timer = null; }
        }

        // Manual nav handlers — dừng auto-rotate khi user tương tác
        dots.forEach(dot => {
            dot.addEventListener('click', e => {
                e.preventDefault();
                stopAuto();
                setActive(parseInt(dot.dataset.idx, 10) || 0);
            });
        });
        arrows.forEach(arrow => {
            arrow.addEventListener('click', e => {
                e.preventDefault();
                stopAuto();
                setActive(idx + (parseInt(arrow.dataset.dir, 10) || 1));
            });
        });

        // Pause auto-rotate khi hover slot (UX chuẩn carousel)
        slot.addEventListener('mouseenter', stopAuto);
        slot.addEventListener('mouseleave', startAuto);

        startAuto();
    }

    function init() {
        document.querySelectorAll('.banner-slot').forEach(initSlot);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
